import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Phone01 = function Phone01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 17.5h.01M8.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.4802 19 19.9201 19 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 2 16.9201 2 15.8 2H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 3.5198 5 4.08 5 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C6.5198 22 7.08 22 8.2 22m4.3-4.5a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 17.5"
    })
  }));
};
export default Phone01;